import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f225f064"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "expandmenu" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]

import {inject, ref} from "vue";
import { circuitConfigInjectionKey } from './CircuitManager';
import { drawSVG } from "./CircuitAnalyzer";
import CircuitCreator from "./CircuitCreator.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'CircuitSelector',
  setup(__props) {

const circuitStore = inject(circuitConfigInjectionKey);
const focus = ref(false);
const editing = ref(false);
const expand = function(){
    editing.value = !editing.value;
}

const click = function(e:Event){
    if(!(e.target as Element).closest(".expandmenu")){
        focus.value = !focus.value;
    }
}
const close = function(){
    focus.value = false;
}
const select = function(id: string){
    circuitStore?.circuits.forEach(c=>{
        c.selected = (c.id === id)? true: false;
    });
    close();
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "dropdown",
    onClick: _withModifiers(click, ["prevent"])
  }, [
    _createTextVNode(_toDisplayString(_unref(circuitStore)?.circuits.filter(c=>c.selected)[0].comment) + " ", 1),
    _createElementVNode("div", {
      class: "display",
      innerHTML: _unref(drawSVG)(_unref(circuitStore)?.circuits.filter(c=>c.selected)[0].nodes).outerHTML
    }, null, 8, _hoisted_2),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["options", {overflown: _unref(circuitStore)?.circuits.length! > 2}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(circuitStore)?.circuits, (circuit, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "option",
            key: index,
            onClick: ($event: any) => (select(circuit.id))
          }, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(circuit.comment) + " ", 1),
              (circuit.selected)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(Selected)"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "display",
              innerHTML: 
                    _unref(drawSVG)(circuit.nodes).outerHTML
            }, null, 8, _hoisted_6)
          ], 8, _hoisted_4))
        }), 128))
      ], 2), [
        [_vShow, !editing.value]
      ]),
      _createElementVNode("div", {
        class: "create",
        onClick: expand
      }, _toDisplayString(editing.value?"Hide":"Create new"), 1),
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(CircuitCreator, {
            class: "edit",
            onFinish: expand
          }, null, 512), [
            [_vShow, editing.value]
          ])
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, focus.value]
    ])
  ], 8, _hoisted_1)), [
    [_directive_click_outside, close]
  ])
}
}

})